import View from "../framework/view";
import template from "../../pugc/upload";
import Server from "../server";
import {Recording} from "../bo/recording";
import {formToJson} from "../misc/utils";
import Alerts from "../misc/alerts";

export class UploadView extends View {

    static classname = "upload-view";

    private readonly server = Server.instance();

    private recording: Recording = {};

    private urls : { [ name: string ] : string } = {};

    constructor(id?: number) {
        super(UploadView.classname);
        if (id) {
            this.server.fetchRecording(id).then((recording) => {
                this.recording = recording;
                // @ts-ignore
                this.recording["main_recording"] = recording.url;
                this.update();
            });
        }
    }

    setRecording(r: Recording) {
        this.recording = r;
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            recording: this.recording,
            urls: this.urls,
            libraries: [ "TALC" ],
            genres: [ "tango", "vals", "milonga" ]
        };

        const out = this.pug(template, data);

        out.find(".with-validation").validate({
            rules: {
                title: "required",
                artist: "required",
                genre: "required",
                recording_date: "required",
                price: "required",
            }
        });

        return out;
    }

    private updateModel() {
        formToJson(this.elt().find("form.recording"), this.recording);
    }

    async upload(name: string, input: JQuery<HTMLInputElement>) {

        const file = input[0].files && input[0].files.length && input[0].files[0];

        if (! file) {
            return;
        }

        const statusElt = input.closest(".line").find(".upload-status");

        const listener = (status: string) => {
            statusElt.text(status);
        }

        const url = await this.server.uploadToS3(file, listener);

        this.urls[name] = url;
        this.update(".files");
    }

    async save() {
        this.updateModel();

        const form = this.elt().find(".with-validation");
        if (! form.valid()) {
            return;
        }

        if (! this.urls.main_recording && ! this.recording.id) {
            Alerts.alert("Missing main recording");
            return;
        }
        if (! this.urls.sample_recording && ! this.recording.id) {
            Alerts.alert("Missing sample recording");
            return;
        }

        const done = await this.server.saveRecording(this.recording, this.urls.main_recording, this.urls.sample_recording);

        Alerts.alert("Saved");
    }
}

View.on(
    "." + UploadView.classname,
    "change",
    "input.upload",
    function(that: UploadView, event, elt) {
        event.preventDefault();
        const input = jQuery(elt) as JQuery<HTMLInputElement>;
        const name = jQuery(elt).attr("name") as any as string;
        that.upload(name, input);
    });

View.on(
    "." + UploadView.classname,
    "click",
    ".save",
    function(that: UploadView, event, elt) {
        event.preventDefault();
        that.save();
    });
